import userPages from './userPages';
import universitiesPages from './universityPages';
import utilities from './utilities';
import other from './other';
import dataPages from './skillAndCoursePages';
import industryPages from './industryPage';
import questionPage from './questionPage';
import geographyPages from './geographyPages';
import notificationPages from './notificationPages';
import languagePages from './languagePage';
import FeedbackPages from './feedbackPage';

// ==============================|| MENU ITEMS ||============================== //

const menuItemsV1 = {
    items: [userPages, utilities, other]
};

const menuItems = {
    items: [userPages, notificationPages, universitiesPages,dataPages,industryPages,questionPage,geographyPages,languagePages,FeedbackPages]
};

export { menuItemsV1 };

export default menuItems;
